export class SubSubject {
    subject: string;
    typeCount: number;
    wrongAnswerCount: number;

    constructor(type: Object = {}) {
        Object.assign(this, type);
    }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/SubSubject.ts